import React from "react";
import useLanguageChange from "../../hooks/useLanguageChange";

const RecordingBlinkIcon = () => {
    const localisedValues = useLanguageChange();

    return (
        <div className='topbar-button'>
            <div className='recording-mark'>
                <div className='recording-mark-icon'>
                    <div className='recording-dots'></div>
                </div>
                <div className='recording-text'>{localisedValues?.rec}</div>
            </div>
        </div>
    );
};

export default RecordingBlinkIcon;
